import { render, staticRenderFns } from "./DDCredits.vue?vue&type=template&id=2409336f&"
import script from "./DDCredits.vue?vue&type=script&lang=js&"
export * from "./DDCredits.vue?vue&type=script&lang=js&"
import style0 from "./DDCredits.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports